import { ShieldAlert, Smartphone } from "lucide-react";
import { SummaryMetrics, type SummaryMetric } from "../../design-system";
import "./machine-monitoring.css";

/** pendingDeviceCount is the API's unauthorized count, not all unavailable phones. */
export function MachineDeviceSummary({
  deviceCount,
  pendingDeviceCount,
  extra = [],
}: {
  deviceCount: number;
  pendingDeviceCount: number;
  extra?: SummaryMetric[];
}) {
  return (
    <div className="meta-crew-machine-device-summary">
      <SummaryMetrics
        density="compact"
        columns={2}
        label="머신 요약"
        items={[
          {
            label: "폰",
            value: deviceCount,
            icon: <Smartphone />,
            tone: "teal",
          },
          {
            label: "승인 대기",
            value: pendingDeviceCount,
            icon: <ShieldAlert />,
            tone: pendingDeviceCount > 0 ? "amber" : "neutral",
          },
          ...extra,
        ]}
      />
    </div>
  );
}
